/** Keep in sync with backend PASSWORD_MIN_LENGTH (NIST SP 800-63B). */
export const PASSWORD_MIN_LENGTH = 8

export function isValidEmail(value) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value || '')
}

/**
 * Focus a Vuetify text-field ref when present.
 * @param {import('vue').Component|undefined|null} fieldRef
 */
export function focusField(fieldRef) {
	if (fieldRef && typeof fieldRef.focus === 'function') {
		fieldRef.focus()
	}
}
